import React, { Component } from 'react';
import * as style from '../magazine/promo.module.scss';
import Reveal from '../ui/reveal';
import BottomCallouts from '../article/bottomCallouts';

class Promo extends Component {
	render() {
		const {
			promo,
			size
		} = this.props;
		const availableSizes = ['small', 'medium', 'large'];
		let promoSize = size;
		
		if(!availableSizes.includes(promoSize)) {
			promoSize = 'large';
		}

		return (
			<div className={`${style.wrapper} ${style[promoSize]}`}>
				<Reveal>
					<BottomCallouts
						itemCallouts={[{
							calloutHeading: promo.title,
							calloutSubtitle: promo.callout_subtitle,
							calloutPath: promo.path,
							cta_link: promo.cta_link ? promo.cta_link : '',
							src: promo.image ? promo.image.sizes.wide_md : '',
							altText: promo.image ? promo.image.alt_text : '',
							opacity: .75,
						}]}
					/>
				</Reveal>
			</div>
		)
	}
}

export default Promo;
